import { render } from "./ReturnDetails.vue?vue&type=template&id=e06abf10&scoped=true"
import script from "./ReturnDetails.vue?vue&type=script&lang=js"
export * from "./ReturnDetails.vue?vue&type=script&lang=js"

import "./ReturnDetails.vue?vue&type=style&index=0&id=e06abf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06abf10"]])

export default __exports__